
import { defineComponent, PropType, toRef } from 'vue';
import { useVModel } from 'vue-composable';
import { Vendor } from '@/types/app';
import { useStore } from '@/store';
import { formDefaults } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';
import VendorMaterialsStockSelector from '@/components/form-controls/VendorMaterialsStockSelector.vue';
import LocationInput from '@/components/form-controls/LocationInput.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import TelInput from '@/components/form-controls/base/TelInput.vue';
import CheckboxInput from '@/components/form-controls/base/CheckboxInput.vue';
import { addOrEditHeader, useAddEditFormState } from '@/utils';

export default defineComponent({
  name: 'VendorAddEditFormModal',
  emits: ['update:openState'],
  components: {
    AppModal,
    VendorMaterialsStockSelector,
    LocationInput,
    GoogleMap,
    TextInput,
    TelInput,
    CheckboxInput
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    vendor: {
      type: Object as PropType<Vendor>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');
    const header = addOrEditHeader(toRef(props, 'vendor'));

    const store = useStore();
    const vendorState = useAddEditFormState(
      toRef(props, 'vendor'),
      formDefaults.vendor,
      store.dispatch.vendors.update,
      store.dispatch.vendors.create
    );

    return {
      isOpen,
      header,
      vendorState
    };
  }
});
